import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "candidate"]
  static values = { requiresCandidate: Boolean }

  connect() {
    this.updateSubmitState()
  }

  onInputChange() {
    this.updateSubmitState()
  }

  onCandidateChange() {
    this.updateSubmitState()
  }

  updateSubmitState() {
    if (!this.hasSubmitTarget) return

    const hasUrl = this.hasInputTarget && this.inputTarget.value.trim().length > 0
    const hasCandidate = !this.requiresCandidateValue || (this.hasCandidateTarget && this.candidateTarget.value.trim().length > 0)
    this.submitTarget.disabled = !(hasUrl && hasCandidate)
  }
}
